var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menu)?_c('nav',{staticClass:"teaser-menu"},[_c('ce-header',_vm._b({},'ce-header',_vm.$props,false)),_vm._v(" "),_c('TeaserMenuItem',{attrs:{"menu":_vm.menu}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }